import * as actionTypes from "./actionTypes";

const initialState = {
  processing: false,
  clusterState: -1, // -1: OFF, 0: PROCESSING, 1: ON
  errors: {},
  errorMessage: "",
};

const Clusters = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROCESSING:
      return {
        ...state,
        processing: action.payload,
      };
    case actionTypes.SET_CLUSTER_STATE:
      return {
        ...state,
        clusterState: action.payload,
      };
    case actionTypes.GET_CLUSTER_STATE_SUCCESS:
        return {
            ...state,
            processing: false,
            clusterState: action.payload,
            errors: {},
            errorMessage: "",
        };
    case actionTypes.GET_CLUSTER_STATE_FAILURE:
        return {
            ...state,
            processing: false,
            clusterState: -1,
            errors: action.payload.data,
            errorMessage: action.payload.message
        };
    case actionTypes.CLUSTER_START_SUCCESS:
        return {
            ...state,
            processing: false,
            clusterState: 1,
            errors: {},
            errorMessage: "",
        };
    case actionTypes.CLUSTER_START_FAILURE:
        return {
            ...state,
            processing: false,
            clusterState: -1,
            errors: action.payload.data,
            errorMessage: action.payload.message
        };
    case actionTypes.CLUSTER_STOP_SUCCESS:
        return {
            ...state,
            processing: false,
            clusterState: -1,
            errors: {},
            errorMessage: "",
        };
    case actionTypes.CLUSTER_STOP_FAILURE:
        return {
            ...state,
            processing: false,
            clusterState: 1,
            errors: action.payload.data,
            errorMessage: action.payload.message
        };
    default:
        return state;
    }
};

export default Clusters;